import { Button, Link } from 'react-admin'
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded'
import { usePreview } from '../../hooks/usePreview'
import { PreviewButtonProps } from './type'

export const PreviewButton: React.FC<PreviewButtonProps> = ({
  to = '',
  target = '_blank',
  ...props
}): JSX.Element => {
  const { previewPath } = usePreview()
  return (
    <Link to={to ? to : previewPath} target={target}>
      <Button size='medium' startIcon={<LaunchRoundedIcon />} label='ra.action.preview' {...props}>
        <LaunchRoundedIcon />
      </Button>
    </Link>
  )
}
